import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { catchError, tap, throwError } from 'rxjs';
import { SettingsAction } from './settings.action';
import { SettingsType } from 'src/app/shared/types/settings.type';
import { SettingsService } from 'src/app/services/settings/settings.service';

@State<SettingsType>({
  name: 'settings',
  defaults: {
    appInfo: null,
    isLoading: false,
  },
})
@Injectable()
export class SettingsState {
  static getAppInfo = () =>
    createSelector([SettingsState], (state: SettingsType) => state.appInfo);

  static getIsLoading = () =>
    createSelector([SettingsState], (state: SettingsType) => state.isLoading);

  constructor(private service: SettingsService) {}

  @Action(SettingsAction.GetAppInfo)
  detail(ctx: StateContext<SettingsType>, action: SettingsAction.GetAppInfo) {
    ctx.patchState({ isLoading: true });
    return this.service.getAppInfo().pipe(
      tap((data) => {
        ctx.patchState({ appInfo: data, isLoading: false });
      }),
      catchError((error) => {
        ctx.patchState({ isLoading: false });
        return throwError(() => error);
      })
    );
  }
}
